export default {
  DEFAULT_STATE: "quiz-app/quizzes/default-state",
};
